<template>
    <div class="col-12 col-md-8 offset-lg-1 order-1 order-md-2 contact--form-col">
        <form action="#" method="POST">
            <div class="form-group">
                <input type="text" :class="['form-control',  {'is-invalid': form.errors.has('name')}]" v-model="form.name" placeholder="Ime in Priimek *" required>
                <div class="invalid-feedback">
                    <template v-if="form.errors.has('name')">
                        {{ form.errors.get('name') }}
                    </template>
                </div>
            </div>
            <div class="form-group">
                <input type="email" :class="['form-control',  {'is-invalid': form.errors.has('email')}]" v-model="form.email" placeholder="E-mail *" required>
                <div class="invalid-feedback">
                    <template v-if="form.errors.has('email')">
                        {{ form.errors.get('email') }}
                    </template>
                </div>
            </div>
            <div class="form-group">
                <input type="text" :class="['form-control',  {'is-invalid': form.errors.has('phone')}]" v-model="form.phone" placeholder="Telefon">
                <div class="invalid-feedback">
                    <template v-if="form.errors.has('phone')">
                        {{ form.errors.get('phone') }}
                    </template>
                </div>
            </div>
            <div class="form-group">
                <input type="text" :class="['form-control',  {'is-invalid': form.errors.has('subject')}]" v-model="form.subject" placeholder="Zadeva *" required>
                <div class="invalid-feedback">
                    <template v-if="form.errors.has('subject')">
                        {{ form.errors.get('subject') }}
                    </template>
                </div>
            </div>
            <div class="form-group">
                <textarea :class="['form-control',  {'is-invalid': form.errors.has('message')}]" rows="5" v-model="form.message" placeholder="Vaše sporočilo *" required></textarea>
                <div class="invalid-feedback">
                    <template v-if="form.errors.has('message')">
                        {{ form.errors.get('message') }}
                    </template>
                </div>
            </div>
            <div class="form-group">
                <div class="checkbox">
                    <label>
                        <input type="checkbox" v-model="form.tos" name="tos" value="1">
                        <span>
                            Strinjam se s
                            <a href="/stran/politika-zasebnosti" target="_blank">Politiko zasebnosti.</a>
                        </span>
                    </label>
                </div>
                <div class="invalid-feedback">
                    <template v-if="form.errors.has('tos')">
                        {{ form.errors.get('tos') }}
                    </template>
                </div>
            </div>
            <div class="text-center">
                <button class="btn btn-primary" @click.prevent="submit">POŠLJI SPOROČILO</button>
            </div>
            <div class="text-center mt-2" v-if="success">
                <strong>Sporočilo poslano. Kontaktirali vas bomo v najkrajšem možnem času.</strong>
            </div>
        </form>
    </div>
</template>

<script>
import to from '@Utils/to'
import Request from '@Utils/request'

export default {
    data() {
        return {
            success: false,
            loading: false,
            form: new Request({
                name: '',
                email: '',
                phone: '',
                subject: '',
                message: '',
                tos: false
            })
        }
    },

    methods: {
        async submit() {
            this.loading = true;
            let [err, response] = await to(this.form.post('contact'))
            this.success = response && response.success
            this.loading = false;
        }
    }
}
</script>

<style lang="scss" scoped>
    input, textarea, .checkbox {
        margin-bottom: 0;
    }

    .invalid-feedback {
        height: 20px;
        padding: 0 0 0 1rem;
        margin: 10px 0 10px;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/ContactForm.vue